import { render, staticRenderFns } from "./Leading.vue?vue&type=template&id=4c049cdb&"
import script from "./Leading.vue?vue&type=script&lang=js&"
export * from "./Leading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports